import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import RoutContainer from "./container/RoutContainer";
import "./index.css";
import Nav from "./components/Navbar/Nav";
import Theme from "./utils/Theme";
import { LoginProvider } from "./context/Login/LoginContext";
import { LoadingProvider } from "./context/Loading/LoadingContext";
import Menu from "./components/Menu/Menu";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LoadingProvider>
      <LoginProvider>
        <BrowserRouter>
          <div
            dir="rtl"
            className="min-h-[100vh] bg-lightPrimary dark:bg-darkPrimary "
          >
            <Nav />
            <RoutContainer />
            <Menu />
          </div>
        </BrowserRouter>
      </LoginProvider>
    </LoadingProvider>
  </React.StrictMode>
);
